(function (window, document) {
  var variantCache = {};
  var productCache = {};
  var hydrating = false;
  var pdpLockBound = false;

  function soldOutLabel() {
    if (window.theme && window.theme.variantStrings && window.theme.variantStrings.soldOut) {
      return window.theme.variantStrings.soldOut;
    }
    return 'Sold out';
  }

  function fetchVariant(variantId) {
    var id = String(variantId);
    if (!variantCache[id]) {
      variantCache[id] = fetch('/variants/' + id + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('variant fetch failed');
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }
    return variantCache[id];
  }

  /**
   * Product-level availability (same as Liquid product.available):
   * available if ANY variant is available.
   */
  function isProductAvailable(variantIds) {
    if (!variantIds || !variantIds.length) return Promise.resolve(false);

    function checkNext(index) {
      if (index >= variantIds.length) return Promise.resolve(false);

      return fetchVariant(variantIds[index]).then(function (variant) {
        if (variant && variant.available === true) return true;
        return checkNext(index + 1);
      });
    }

    return checkNext(0);
  }

  function getProductAvailability(productId, variantIds) {
    var key = String(productId);

    if (Object.prototype.hasOwnProperty.call(productCache, key)) {
      return productCache[key];
    }

    productCache[key] = isProductAvailable(variantIds).then(function (available) {
      return available === true;
    });

    return productCache[key];
  }

  function parseMap(raw) {
    try {
      return JSON.parse(raw || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function getActiveVariantMap(el) {
    var mapsEl = document.getElementById('EbBundleVariantMaps');
    if (mapsEl) {
      var maps = parseMap(mapsEl.textContent);
      var idInput = document.querySelector('form[data-type="add-to-cart-form"] [name="id"], product-form [name="id"]');
      var variantId = idInput && String(idInput.value || '');

      if (variantId && maps[variantId]) return maps[variantId];

      var keys = Object.keys(maps);
      for (var i = 0; i < keys.length; i++) {
        if (maps[keys[i]]) return maps[keys[i]];
      }
    }

    return parseMap(el.getAttribute('data-eb-variant-map'));
  }

  function markCardSoldOut(el) {
    var column = el.closest('li.column');
    if (column) column.classList.add('ctm_soldout');

    var card = el.closest('product-card') || el.closest('.product-card');
    if (!card) return;

    card.classList.add('eb-component-soldout');

    var badges = card.querySelector('.price .badges');
    if (badges && !badges.querySelector('.out-of-stock')) {
      var badge = document.createElement('span');
      badge.className = 'badge out-of-stock';
      badge.textContent = soldOutLabel();
      badges.appendChild(badge);
    }

    card.querySelectorAll('.product-card--add-to-cart-button').forEach(function (button) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('sold-out');

      var text = button.querySelector('.product-card--add-to-cart-text');
      if (text) text.textContent = soldOutLabel();
    });
  }

  /**
   * Match existing PDP sold-out state from Liquid / product.js:
   * disabled + .sold-out + sold out label on .single-add-to-cart-button
   * + out-of-stock badge beside price
   */
  function applyPdpSoldOutUi() {
    window.__ebBundleProductSoldOut = true;

    document.querySelectorAll('.single-add-to-cart-button').forEach(function (button) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('sold-out');

      var text = button.querySelector('.single-add-to-cart-button--text');
      if (text) text.textContent = soldOutLabel();
    });

    // PDP: .badges is a sibling of .price inside .product-price-container (not nested)
    document.querySelectorAll('.product-price-container .badges').forEach(function (badges) {
      if (badges.querySelector('.out-of-stock')) return;
      var badge = document.createElement('span');
      badge.className = 'badge out-of-stock';
      badge.textContent = soldOutLabel();
      badges.appendChild(badge);
    });
  }

  function bindPdpSoldOutLock() {
    if (pdpLockBound) return;
    pdpLockBound = true;

    document.addEventListener(
      'change',
      function () {
        if (window.__ebBundleProductSoldOut) applyPdpSoldOutUi();
      },
      true
    );

    var observeRoots = [];
    var form = document.querySelector('product-form, form[data-type="add-to-cart-form"]');
    if (form) observeRoots.push(form);
    document.querySelectorAll('.product-price-container').forEach(function (el) {
      observeRoots.push(el);
    });

    if (!observeRoots.length) return;

    var timer;
    var observer = new MutationObserver(function () {
      if (!window.__ebBundleProductSoldOut) return;

      clearTimeout(timer);
      timer = setTimeout(function () {
        var needsFix = false;

        document.querySelectorAll('.single-add-to-cart-button').forEach(function (button) {
          if (!button.disabled || !button.classList.contains('sold-out')) needsFix = true;
        });

        document.querySelectorAll('.product-price-container .badges').forEach(function (badges) {
          if (!badges.querySelector('.out-of-stock')) needsFix = true;
        });

        if (needsFix) applyPdpSoldOutUi();
      }, 30);
    });

    observeRoots.forEach(function (root) {
      observer.observe(root, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'class']
      });
    });
  }

  function checkMapSoldOut(map) {
    var productIds = Object.keys(map || {});
    if (!productIds.length) return Promise.resolve(false);

    return Promise.all(
      productIds.map(function (productId) {
        return getProductAvailability(productId, map[productId] || []);
      })
    ).then(function (availabilityList) {
      return availabilityList.some(function (available) {
        return available === false;
      });
    });
  }

  function hydrateElement(el) {
    if (el.getAttribute('data-hydrated') === 'true') return;

    var isPdp = el.getAttribute('data-eb-context') === 'pdp';
    var map = isPdp ? getActiveVariantMap(el) : parseMap(el.getAttribute('data-eb-variant-map'));
    var productIds = Object.keys(map || {});
    if (!productIds.length) return;

    el.setAttribute('data-hydrated', 'true');

    checkMapSoldOut(map).then(function (anyProductSoldOut) {
      if (!anyProductSoldOut) return;

      if (isPdp) {
        applyPdpSoldOutUi();
        bindPdpSoldOutLock();
      } else {
        markCardSoldOut(el);
      }
    });
  }

  function hydrateAll() {
    if (hydrating) return;
    hydrating = true;

    document.querySelectorAll('.product-card-eb-availability:not([data-hydrated="true"])').forEach(hydrateElement);

    hydrating = false;
  }

  window.ebHydrateComponentAvailability = hydrateAll;

  var ebMapCache = {};

  function getHandleFromHref(href) {
    if (!href) return '';
    var match = String(href).match(/\/products\/([^\/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function fetchEbMapByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(ebMapCache, handle)) {
      return ebMapCache[handle];
    }

    ebMapCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=eb-map')
      .then(function (response) {
        if (!response.ok) throw new Error('eb-map fetch failed');
        return response.text();
      })
      .then(function (text) {
        var start = text.indexOf('{');
        var end = text.lastIndexOf('}');
        if (start < 0 || end < start) return null;
        return JSON.parse(text.slice(start, end + 1));
      })
      .catch(function () {
        return null;
      });

    return ebMapCache[handle];
  }

  function findFlitsWishlistCard(link) {
    var node = link;
    for (var i = 0; i < 10 && node; i++) {
      node = node.parentElement;
      if (!node || node.id === 'flits_custom_wishlist_append') break;

      var links = node.querySelectorAll('a[href*="/products/"]');
      if (links.length === 1 && node.querySelector('button, [class*="price"], [class*="Price"]')) {
        return node;
      }
    }

    return link.closest('[class*="flits_"]') || link.parentElement; 
  }

  function markFlitsWishlistCardSoldOut(card) {
    if (!card || card.getAttribute('data-eb-soldout') === 'true') return;
    card.setAttribute('data-eb-soldout', 'true');
    card.classList.add('eb-component-soldout');

    var badgeHost =
      card.querySelector('[class*="badge"]') ||
      card.querySelector('[class*="price"]') ||
      card.querySelector('[class*="Price"]') ||
      card;

    if (badgeHost && !card.querySelector('.badge.out-of-stock')) {
      var badge = document.createElement('span');
      badge.className = 'badge out-of-stock eb-flits-soldout-badge';
      badge.textContent = soldOutLabel();

      if (badgeHost !== card) {
        badgeHost.appendChild(badge);
      } else {
        card.insertBefore(badge, card.firstChild);
      }
    }

    card.querySelectorAll('button').forEach(function (button) {
      if (
        button.closest(
          '.flits-collection-page-wishlist-button'
        )
      ) {
        return;
      }
      var label = (button.textContent || '').trim().toLowerCase();
      var isAtc =
        label.indexOf('add') !== -1 ||
        label.indexOf('select') !== -1 ||
        label.indexOf('cart') !== -1 ||
        label.indexOf('option') !== -1 ||
        label.indexOf('buy') !== -1;

      if (!isAtc) return;

      button.setAttribute('disabled', 'disabled');
      button.classList.add('sold-out');
      button.textContent = soldOutLabel();
    });
  }

  function hydrateFlitsWishlist() {
    var root = document.getElementById('flits_custom_wishlist_append');
    if (!root) return;

    var links = root.querySelectorAll('a[href*="/products/"]');
    var seen = {};

    links.forEach(function (link) {
      var handle = getHandleFromHref(link.getAttribute('href'));
      if (!handle || seen[handle]) return;
      seen[handle] = true;

      var card = findFlitsWishlistCard(link);
      if (!card || card.getAttribute('data-eb-checked') === 'true') return;
      card.setAttribute('data-eb-checked', 'true');

      fetchEbMapByHandle(handle).then(function (payload) {
        if (!payload || !payload.map) return;

        return checkMapSoldOut(payload.map).then(function (anyProductSoldOut) {
          if (anyProductSoldOut) markFlitsWishlistCardSoldOut(card);
        });
      });
    });
  }

  function bindFlitsWishlistObserver() {
    var root = document.getElementById('flits_custom_wishlist_append');
    if (!root || root.getAttribute('data-eb-wishlist-observed') === 'true') return;

    root.setAttribute('data-eb-wishlist-observed', 'true');

    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(hydrateFlitsWishlist, 80);
    }).observe(root, { childList: true, subtree: true });

    hydrateFlitsWishlist();
  }

  function bindGridObserver() {
    var grid = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (!grid || grid.getAttribute('data-eb-availability-observed') === 'true') return;

    grid.setAttribute('data-eb-availability-observed', 'true');

    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(hydrateAll, 50);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (!window.__ebComponentAvailabilityBound) {
    window.__ebComponentAvailabilityBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        hydrateAll();
        bindGridObserver();
        bindFlitsWishlistObserver();
      });
    } else {
      hydrateAll();
      bindGridObserver();
      bindFlitsWishlistObserver();
    }

    document.addEventListener('shopify:section:load', function () {
      hydrateAll();
      bindGridObserver();
      bindFlitsWishlistObserver();
    });
    document.addEventListener('pagination:page-changed', hydrateAll);
    window.addEventListener('collection-filter-changed', hydrateAll);
  } else {
    hydrateAll();
    bindGridObserver();
    bindFlitsWishlistObserver();
  }
})(window, document);
